import { Router } from '@angular/router';
import { NotificationSlugEnum } from '@app/generated/graphql';
import { INotificationConfig } from '../interfaces/interface';
import { DEFAULT_MESSAGE_LIFE } from './notification.constants';

const DISPLAY_TITLE = 'Client change request';
const DISPLAY_DESCRIPTION = 'A masterfile setup request has been updated.';

export function createClientChangeRequestNotificationConfig(
  router: Router,
): INotificationConfig {
  return {
    slug: NotificationSlugEnum.ClientChangeRequest,
    preference: {
      displayTitle:
        'A new masterfile setup I have requested has been activated',
      displayDescription:
        'Get notified when requests for new data setups for packhouses, farms, exporters and coldstores have been actioned.',
      defaultConfig: {},
    },
    message: {
      iconPath: '/assets/icons/general/info.svg',
      displayTitle: DISPLAY_TITLE,
      displayDescription: DISPLAY_DESCRIPTION,
      resolveDisplayTitle: (
        metadata: Record<string, unknown>,
      ): string | undefined => {
        switch (metadata['status']) {
          case 'approved':
            return 'Requested Masterfile Setup approved';
          case 'rejected':
            return 'Requested Masterfile Setup rejected';
          default:
            return DISPLAY_TITLE;
        }
      },
      resolveDisplayDescription: (
        metadata: Record<string, unknown>,
      ): string | undefined => {
        const requestType = metadata['request_type'] as string | undefined;
        const packhouseName = metadata['packhouse_name'] as string | undefined;
        const exporterName = metadata['exporter_name'] as string | undefined;

        switch (requestType) {
          case 'internal_packhouse':
            return packhouseName
              ? `Setups for requested packhouse ${packhouseName} complete.`
              : DISPLAY_DESCRIPTION;
          case 'external_packhouse':
            return packhouseName
              ? `Setups for requested external packhouse ${packhouseName} complete.`
              : DISPLAY_DESCRIPTION;
          case 'company_association_for_existing_company':
          case 'company_association_for_missing_company':
            return exporterName
              ? `Setups requested for exporter ${exporterName} complete.`
              : DISPLAY_DESCRIPTION;
          default:
            return DISPLAY_DESCRIPTION;
        }
      },
      actionLabel: 'View',
      action: (metadata: Record<string, unknown>) => {
        const requestType = metadata['request_type'] as string | undefined;
        if (!requestType) {
          return;
        }

        switch (requestType) {
          case 'internal_packhouse':
          case 'external_packhouse':
            router.navigate(['/account/masterfiles/packhouse-manager']);
            break;
          case 'company_association_for_existing_company':
          case 'company_association_for_missing_company':
            router.navigate(['/account/masterfiles/supply-chain-setup']);
            break;
        }
      },
      life: DEFAULT_MESSAGE_LIFE,
    },
  };
}
